// Auto-generated from /schemas/configs/ — do not edit manually.
// Regenerate with: cd schemas && just codegen

import type {
    AgentHttpConfig,
    AgentsConfig,
    AiSectionsConfig,
    AnalyticsConfig,
    AppearanceConfig,
    BackofficeConfig,
    BehaviorConfig,
    ChatgptConfig,
    CompetitorsConfig,
    ContentConfig,
    ContentGatingConfig,
    CtasConfig,
    EngagementConfig,
    FormAssistantConfig,
    GeoConfig,
    IdentityConfig,
    InchatBookingConfig,
    IntegrationsConfig,
    InternalIpFilterConfig,
    OnboardingConfig,
    QualificationConfig,
    StaffHoldoutOptOutConfig,
    SystemConfig,
    TrackingStatusConfig,
    TrafficControlConfig,
    WebmcpConfig,
} from '../../types/configs.generated';

/**
 * Typed accessor getters for all config slugs.
 * Generated from schema x-feature metadata.
 * Non-features return T, features return T | null.
 */
export abstract class ConfigAccessors {
    abstract getConfig<T>(slug: string): T | null;

    get agents(): AgentsConfig {
        const cfg = this.getConfig<AgentsConfig>('agents');
        if (!cfg) throw new Error('agents is a non-feature config and should never be null');
        return cfg;
    }

    get backoffice(): BackofficeConfig {
        const cfg = this.getConfig<BackofficeConfig>('backoffice');
        if (!cfg) throw new Error('backoffice is a non-feature config and should never be null');
        return cfg;
    }

    get competitors(): CompetitorsConfig {
        const cfg = this.getConfig<CompetitorsConfig>('competitors');
        if (!cfg) throw new Error('competitors is a non-feature config and should never be null');
        return cfg;
    }

    get identity(): IdentityConfig {
        const cfg = this.getConfig<IdentityConfig>('identity');
        if (!cfg) throw new Error('identity is a non-feature config and should never be null');
        return cfg;
    }

    get agent_http(): AgentHttpConfig | null {
        return this.getConfig<AgentHttpConfig>('agent_http');
    }

    get ai_sections(): AiSectionsConfig | null {
        return this.getConfig<AiSectionsConfig>('ai_sections');
    }

    get analytics(): AnalyticsConfig {
        const cfg = this.getConfig<AnalyticsConfig>('analytics');
        if (!cfg) throw new Error('analytics is a non-feature config and should never be null');
        return cfg;
    }

    get appearance(): AppearanceConfig {
        const cfg = this.getConfig<AppearanceConfig>('appearance');
        if (!cfg) throw new Error('appearance is a non-feature config and should never be null');
        return cfg;
    }

    get behavior(): BehaviorConfig {
        const cfg = this.getConfig<BehaviorConfig>('behavior');
        if (!cfg) throw new Error('behavior is a non-feature config and should never be null');
        return cfg;
    }

    get chatgpt(): ChatgptConfig {
        const cfg = this.getConfig<ChatgptConfig>('chatgpt');
        if (!cfg) throw new Error('chatgpt is a non-feature config and should never be null');
        return cfg;
    }

    get content(): ContentConfig | null {
        return this.getConfig<ContentConfig>('content');
    }

    get content_gating(): ContentGatingConfig | null {
        return this.getConfig<ContentGatingConfig>('content_gating');
    }

    get ctas(): CtasConfig {
        const cfg = this.getConfig<CtasConfig>('ctas');
        if (!cfg) throw new Error('ctas is a non-feature config and should never be null');
        return cfg;
    }

    get engagement(): EngagementConfig | null {
        return this.getConfig<EngagementConfig>('engagement');
    }

    get form_assistant(): FormAssistantConfig | null {
        return this.getConfig<FormAssistantConfig>('form_assistant');
    }

    get geo(): GeoConfig | null {
        return this.getConfig<GeoConfig>('geo');
    }

    get inchat_booking(): InchatBookingConfig | null {
        return this.getConfig<InchatBookingConfig>('inchat_booking');
    }

    get integrations(): IntegrationsConfig | null {
        return this.getConfig<IntegrationsConfig>('integrations');
    }

    get onboarding(): OnboardingConfig {
        const cfg = this.getConfig<OnboardingConfig>('onboarding');
        if (!cfg) throw new Error('onboarding is a non-feature config and should never be null');
        return cfg;
    }

    get qualification(): QualificationConfig | null {
        return this.getConfig<QualificationConfig>('qualification');
    }

    get staff_holdout_opt_out(): StaffHoldoutOptOutConfig {
        const cfg = this.getConfig<StaffHoldoutOptOutConfig>('staff_holdout_opt_out');
        if (!cfg)
            throw new Error(
                'staff_holdout_opt_out is a non-feature config and should never be null'
            );
        return cfg;
    }

    get system(): SystemConfig {
        const cfg = this.getConfig<SystemConfig>('system');
        if (!cfg) throw new Error('system is a non-feature config and should never be null');
        return cfg;
    }

    get tracking_status(): TrackingStatusConfig {
        const cfg = this.getConfig<TrackingStatusConfig>('tracking_status');
        if (!cfg)
            throw new Error('tracking_status is a non-feature config and should never be null');
        return cfg;
    }

    get traffic_control(): TrafficControlConfig {
        const cfg = this.getConfig<TrafficControlConfig>('traffic_control');
        if (!cfg)
            throw new Error('traffic_control is a non-feature config and should never be null');
        return cfg;
    }

    get webmcp(): WebmcpConfig | null {
        return this.getConfig<WebmcpConfig>('webmcp');
    }

    get internal_ip_filter(): InternalIpFilterConfig {
        const cfg = this.getConfig<InternalIpFilterConfig>('internal_ip_filter');
        if (!cfg)
            throw new Error('internal_ip_filter is a non-feature config and should never be null');
        return cfg;
    }
}
